'use client'

import Loading from '@/components/Loading'
import { PropsWithChildren, createContext, useContext, useEffect, useState } from 'react'

type AppLoaderContextType = {
  isAppLoading: boolean
  setIsAppLoading: (isLoading: boolean) => void
}

const AppLoaderContext = createContext<AppLoaderContextType | null>(null)

export function AppLoaderProvider({ children }: PropsWithChildren) {
  const [isAppLoading, setIsAppLoading] = useState(false)

  useEffect(() => {
    if (isAppLoading) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }, [isAppLoading])

  return (
    <AppLoaderContext.Provider value={{ isAppLoading, setIsAppLoading }}>
      {isAppLoading && <Loading />}
      {children}
    </AppLoaderContext.Provider>
  )
}

export const useAppLoaderContext = () => {
  const value = useContext(AppLoaderContext)

  if (value == null) {
    throw new Error('useAppLoaderContext cannot be used outside of AppLoaderProvider')
  }

  return value
}
